/**
 * 判断data是否为空，比如null, undefined, "", "  ", {}, [], [""]
 * 1. undefined or null
 * 2. 长度为0或内容为空白字符的string
 * 3. 长度为0的array
 * 4. 没有内容的object
 * @param data
 * @returns {boolean}
 */
export function isBlank(data: any) {
  const dataType = typeof (data);
  if (dataType === 'number') {
    if (Number.isNaN(data)) {
      return true;
    }
    return false;
  }
  if (dataType === 'boolean') {
    return false;
  }
  if (dataType === 'undefined' || data === null) {
    return true;
  }
  if (typeof (data.length) !== 'undefined') {
    // [""]也会被判断位空
    // 是否是空字符串
    if (/^[\s]*$/.test(data.toString())) {
      return true;
    }
    return data.length === 0;
  }
  for (const i in data) {
    if (data.hasOwnProperty(i)) {
      return false;
    }
  }
  return true;
}

export default isBlank;
